export const OFFICIAL_NOTICE_DOMAINS = [
  "bizinfo.go.kr",
  "iris.go.kr",
  "data.go.kr",
  "gov.kr",
  "k-startup.go.kr",
  "msit.go.kr",
] as const;

export interface UrlValidationResult {
  valid: boolean;
  normalizedUrl: string | null;
  reason: string | null;
}

function domainAllowed(hostname: string, allowlist: readonly string[]): boolean {
  const normalized = hostname.toLocaleLowerCase("en-US").replace(/\.$/u, "");
  return allowlist.some((domain) => normalized === domain || normalized.endsWith(`.${domain}`));
}

export function validateOfficialUrl(
  raw: string | null | undefined,
  allowlist: readonly string[] = OFFICIAL_NOTICE_DOMAINS,
): UrlValidationResult {
  if (!raw?.trim()) return { valid: false, normalizedUrl: null, reason: "URL이 없습니다." };
  let url: URL;
  try {
    url = new URL(raw.trim());
  } catch {
    return { valid: false, normalizedUrl: null, reason: "URL 형식이 올바르지 않습니다." };
  }
  if (url.protocol !== "https:") {
    return { valid: false, normalizedUrl: null, reason: "HTTPS URL만 허용됩니다." };
  }
  if (url.username || url.password) {
    return { valid: false, normalizedUrl: null, reason: "인증정보가 포함된 URL은 허용되지 않습니다." };
  }
  if (url.port && url.port !== "443") {
    return { valid: false, normalizedUrl: null, reason: "비표준 포트는 허용되지 않습니다." };
  }
  if (!domainAllowed(url.hostname, allowlist)) {
    return { valid: false, normalizedUrl: null, reason: "허용된 공식 도메인이 아닙니다." };
  }
  url.hash = "";
  return { valid: true, normalizedUrl: url.toString(), reason: null };
}

export function assertOfficialUrl(
  raw: string,
  allowlist: readonly string[] = OFFICIAL_NOTICE_DOMAINS,
): string {
  const result = validateOfficialUrl(raw, allowlist);
  if (!result.valid || !result.normalizedUrl) throw new TypeError(result.reason ?? "허용되지 않은 URL입니다.");
  return result.normalizedUrl;
}
